import { useState, useEffect, useRef } from "react";
import Modal from "react-modal";
import axios from "axios";
import { toast } from "react-toastify";
import { ButtonSkeleton } from "./CalendarComponents/SkeletonLoader.jsx";
import crossImage from "../../images/singleinvoice/cross-red.svg";

const ManageAttendanceModal = ({
    manageAttendanceModalOpen,
    setManageAttendanceModalOpen,
    selectedEventForEdit,
    user,
    token,
    attendanceStatus,
    setAttendanceStatus,
    attendanceReason,
    setAttendanceReason,
    additionalNotes,
    setAdditionalNotes,
    setLastAdditionalNotes,
    setSelectedAttendee,
    setSelectedEvents,
    setExpandedEventIndex,
    setModalIsOpen,
    ATTENDANCE_STATUSES,
    refetchEvents,
}) => {
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const [attendanceStatusIsValid, setAttendanceStatusIsValid] = useState(false);
    const [attendanceStatusDropdownOpen, setAttendanceStatusDropdownOpen] = useState(false);

    const attendanceStatusRef = useRef(null);

    const handleToggleAttendanceStatusDropdown = () => {
        setAttendanceStatusDropdownOpen(!attendanceStatusDropdownOpen);
    };

    const handleCloseManageAttendanceModal = () => {
        // if (!isSubmitLoading) {
        setManageAttendanceModalOpen(false);
        setSelectedAttendee(null);
        setAttendanceStatus("pending");
        setAttendanceReason("");
        setAdditionalNotes("");
        // setAttendanceStatusIsValid(false);
        document.body.classList.remove("ReactModal__Body--open");
        // }
    };

    const handleManageAttendanceSubmit = async (e) => {
        // e.preventDefault();
        if (e) e.preventDefault();
        // setAttendanceStatusIsValid(false);

        if (!additionalNotes) {
            // setAttendanceStatusIsValid(true);
            toast.error("Please provide notes before submitting.", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            return;
        }

        try {
            setIsSubmitLoading(true);
            const requestData = {
                event_id: selectedEventForEdit._id,
                user_id: user._id,
                // status: attendanceStatus,
                // reason: attendanceReason || null,
                additional_notes: additionalNotes || null,
                timeZone: global.config.getTimeZone(),
            };
            await axios.post("/api/events/update-attendance-notes", requestData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            global.config.activityLog(
                window.location.href,
                "Event Attendance Update",
                `Attendance updated for event "${selectedEventForEdit.eventName}" by user ${user._id}`
            );
            toast.success("Attendance updated successfully", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setLastAdditionalNotes(additionalNotes);
            handleCloseManageAttendanceModal();
            refetchEvents();
            // setModalIsOpen(false);
            // setExpandedEventIndex(null);
            // setSelectedEvents([]);
        } catch (error) {
            console.error("Error updating attendance:", error);
            global.config.slackMessage(error.toString());
            toast.error(error.response?.data?.message || "An error occurred while updating attendance. Please try again later.", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } finally {
            setIsSubmitLoading(false);
        }
    };

    const handleClickOutsideDropdown = (event) => {
        const refs = {
            attendanceStatus: attendanceStatusRef.current,
        };

        // Log any null refs for debugging
        Object.entries(refs).forEach(([key, ref]) => {
            if (!ref) {
                console.warn(`Ref ${key} is null`);
            }
        });

        try {
            if (refs.attendanceStatus && !refs.attendanceStatus.contains(event.target)) {
                setAttendanceStatusDropdownOpen(false);
            }
        } catch (err) {
            console.error('Error in handleClickOutsideDropdown:', err);
        }
    };

    useEffect(() => {
        if (typeof window === 'undefined' || !document) {
            return;
        }

        document.addEventListener('click', handleClickOutsideDropdown);

        return () => {
            document.removeEventListener('click', handleClickOutsideDropdown);
        };
    }, []);

    return (
        <Modal
            className="add-note"
            isOpen={manageAttendanceModalOpen}
            onRequestClose={!isSubmitLoading ? handleCloseManageAttendanceModal : undefined}
            contentLabel="Manage Attendance"
            style={{
                content: {
                    height: "auto",
                    width: "30%",
                    maxWidth: "617px",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                },
            }}
        >
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg p-6 w-full max-w-lg">
                    <div className="modal timeoff-modal">
                        <div className="modal-close-invite outter-modal-main">
                            <a onClick={() => !isSubmitLoading && handleCloseManageAttendanceModal()}>
                                <img src={crossImage} alt="Close Icon" />
                            </a>
                        </div>
                        <div className="modal-client-head" >
                            <h2 style={{ textAlign: "left" }}>Add Notes</h2>
                        </div>
                        <div className="form-field-client-outer">
                            <form onSubmit={handleManageAttendanceSubmit}>
                                {/* <div className="form-field-client">
                                    <label htmlFor="attendanceStatus" className="form-label">
                                        Status *
                                    </label>
                                    <div ref={attendanceStatusRef} className={`cursor ${attendanceStatusDropdownOpen ? 'open' : ''}`}>
                                        <span
                                            id="attendance-status-select"
                                            onClick={handleToggleAttendanceStatusDropdown}
                                            className={`custom-dropdown-user-new custom-dropdown-select ${attendanceStatusIsValid ? 'input-validation-error' : ''}`}
                                        >
                                            {attendanceStatus ? ATTENDANCE_STATUSES.find((status) => status.value === attendanceStatus)?.label : 'Select'}
                                        </span>
                                        {attendanceStatusDropdownOpen && (
                                            <div className="custom-dropdown-new">
                                                <ul className="leave-type-list">
                                                    {ATTENDANCE_STATUSES.map((status) => (
                                                        <li
                                                            key={status.value}
                                                            className={attendanceStatus === status.value ? 'selected-item' : ''}
                                                            onClick={() => {
                                                                setAttendanceStatus(status.value);
                                                                setAttendanceStatusDropdownOpen(false);
                                                                setAttendanceStatusIsValid(false);
                                                            }}
                                                        >
                                                            {status.label}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                    {attendanceStatusIsValid && (
                                        <span className="text-red-500 text-xs italic">
                                            Status is required
                                        </span>
                                    )}
                                </div>
                                {(attendanceStatus === 'no' || attendanceStatus === 'maybe') && (
                                    <div className="form-field-client">
                                        <label htmlFor="reason" className="form-label">
                                            Reason
                                        </label>
                                        <textarea
                                            id="reason"
                                            value={attendanceReason}
                                            onChange={(e) => setAttendanceReason(e.target.value)}
                                            className="form-textarea"
                                            rows="3"
                                            placeholder="Reason for your response (optional)"
                                        ></textarea>
                                    </div>
                                )} */}
                                <div className="form-field-client">
                                    {/* <label htmlFor="additionalNotes" className="form-label">
                                        Additional Notes
                                    </label> */}
                                    <textarea
                                        id="additionalNotes"
                                        value={additionalNotes}
                                        onChange={(e) => setAdditionalNotes(e.target.value)}
                                        className="form-textarea"
                                        rows="3"
                                        placeholder="Write here"
                                    ></textarea>
                                </div>
                                <div className="add-note-btn">
                                    <button type="submit" disabled={isSubmitLoading || attendanceStatus === 'pending'} className="submit-client">
                                        {isSubmitLoading ? (
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                                <ButtonSkeleton width="50px" height="18px" />
                                            </div>
                                        ) : (
                                            "Send"
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ManageAttendanceModal;